import { adminServerInstance } from "../axios/instances";
import {
  HANDLE_USER_MANAGEMENT_AUTH,
  REGISTER_ACCOUNT,
  REGISTER_ACCOUNT_SUCCESS,
  REGISTER_ACCOUNT_FAIL,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  DELETE_ACCOUNT,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAIL,
} from './types.js'

import { USER_MANAGEMENT as type } from "./types";
import { execute } from "../network/executor";

export function handleUserManagementAuth(admin) {
  return function (dispatch) {
    dispatch({ type: HANDLE_USER_MANAGEMENT_AUTH })
    return (
      dispatch({
        type: HANDLE_USER_MANAGEMENT_AUTH,
        payload: admin
      })
    )
  }
}

export function registerAccount(level, username, city_id, authTeam) {
    return function (dispatch) {
        dispatch({type: REGISTER_ACCOUNT})
        return adminServerInstance.post("/map/registeraccount", {
            level: level,
            username: username,
            area: 100,
            city_id: city_id,
            team: authTeam
        })
            .then(({data}) => {
                dispatch({
                    type: REGISTER_ACCOUNT_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: REGISTER_ACCOUNT_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function changePassword(username, oldPassword, newPassword, confirmPassword) {
  return function (dispatch) {
    dispatch({ type: CHANGE_PASSWORD });

    return adminServerInstance.post('/usermanagement/changepassword', {
      username: username,
      oldPassword: oldPassword,
      newPassword: newPassword,
      confirmPassword: confirmPassword
    })
      .then(({ data }) => {
        dispatch({
          type: CHANGE_PASSWORD_SUCCESS,
          payload: data.data
        })
        return Promise.resolve(data.data);
      })
      .catch(error => {
        dispatch({
          type: CHANGE_PASSWORD_FAIL,
          payload: error
        })
        return Promise.reject(error);
      });
  }
}

export function deleteAccount(username) {
  return function (dispatch) {
    dispatch({ type: DELETE_ACCOUNT })
    return adminServerInstance.post("/usermanagement/deleteuser", {
      username: username
    })
      .then(({ data }) => {
        dispatch({
          type: DELETE_ACCOUNT_SUCCESS,
          payload: data.data
        })
        return Promise.resolve(data.data);
      }).catch(error => {
        dispatch({
          type: DELETE_ACCOUNT_FAIL,
          payload: error
        })
        return Promise.reject(error);
      });
  }
}

export const getAbilityList = () => (dispatch) => execute(dispatch)(
  adminServerInstance.get('/auth/abilities'),
  {
    type: type.GET_ABILITY_LIST,
    success: type.GET_ABILITY_LIST_SUCCESS,
    fail: type.GET_ABILITY_LIST_FAIL,
  }
);

export const getAbilityListByUser = (userId) => (dispatch) => execute(dispatch)(
  adminServerInstance.get(`auth/permissions?user_id=${userId}`),
  {
    type: type.GET_ABILITY_LIST_BY_USER,
    success: type.GET_ABILITY_LIST_BY_USER_SUCCESS,
    fail: type.GET_ABILITY_LIST_BY_USER_FAIL,
  }
);

export const getRoleList = () => (dispatch) => execute(dispatch)(
  adminServerInstance.get('/auth/roles'),
  {
    type: type.GET_ROLE_LIST,
    success: type.GET_ROLE_LIST_SUCCESS,
    fail: type.GET_ROLE_LIST_FAIL,
  }
);

export const getRoleListByUser = (userId) => (dispatch) => execute(dispatch)(
  adminServerInstance.get(`auth/assigned_roles?entity_id=${userId}`),
  {
    type: type.GET_ROLE_LIST_BY_USER,
    success: type.GET_ROLE_LIST_BY_USER_SUCCESS,
    fail: type.GET_ROLE_LIST_BY_USER_FAIL,
  }
);

export const getUserList = () => (dispatch) => execute(dispatch)(
  adminServerInstance.get('/auth/users'),
  {
    type: type.GET_USER_LIST,
    success: type.GET_USER_LIST_SUCCESS,
    fail: type.GET_USER_LIST_FAIL,
  }
);

export const getUserListByRole = (roleId) => (dispatch) => execute(dispatch)(
  adminServerInstance.get(`/auth/users?role_id=${roleId}`),
  {
    type: type.GET_USER_LIST_BY_ROLE,
    success: type.GET_USER_LIST_BY_ROLE_SUCCESS,
    fail: type.GET_USER_LIST_BY_ROLE_FAIL,
  }
);

export const createNewRole = (name) => (dispatch) => execute(dispatch)(
  adminServerInstance.post(`auth/roles/create?name=${name}`, {
    title: name,
  }),
  {
    type: type.CREATE_NEW_ROLE,
    success: type.CREATE_NEW_ROLE_SUCCESS,
    fail: type.CREATE_NEW_ROLE_FAIL,
  }
);

export const updateUserInformation = (userId, warehouse) => (dispatch) => execute(dispatch)(
  adminServerInstance.post(`auth/users/update?id=${userId}`, {
    warehouse: warehouse,
  }),
  {
    type: type.UPDATE_USER_INFORMATION,
    success: type.UPDATE_USER_INFORMATION_SUCCESS,
    fail: type.UPDATE_USER_INFORMATION_FAIL,
  }
);

export const deleteRole = (roleId) => (dispatch) => execute(dispatch)(
  adminServerInstance.post(`auth/roles/delete?id=${roleId}`),
  {
    type: type.DELETE_ROLE,
    success: type.DELETE_ROLE_SUCCESS,
    fail: type.DELETE_ROLE_FAIL,
  }
);

export const deleteUser = (userName) => (dispatch) => execute(dispatch)(
  adminServerInstance.post(`usermanagement/deleteuser?username=${userName}`),
  {
    type: type.DELETE_USER,
    success: type.DELETE_USER_SUCCESS,
    fail: type.DELETE_USER_FAIL,
  }
);

export const updateUserRoles = (userId, roles) => (dispatch) => execute(dispatch)(
  adminServerInstance.post(`auth/assigned_roles/update?entity_id=${userId}`, {
    role_ids: roles,
  }),
  {
    type: type.UPDATE_USER_ROLES,
    success: type.UPDATE_USER_ROLES_SUCCESS,
    fail: type.UPDATE_USER_ROLES_FAIL,
  }
);

export const updateRole = (roleId, name) => (dispatch) => execute(dispatch)(
  adminServerInstance.post(`auth/roles/update?id=${roleId}`, {
    name: name,
  }),
  {
    type: type.UPDATE_ROLE_INFORMATION,
    success: type.UPDATE_ROLE_INFORMATION_SUCCESS,
    fail: type.UPDATE_ROLE_INFORMATION_FAIL,
  }
);

export const updateRoleAbilities = (roleId, abilities) => (dispatch) => execute(dispatch)(
  adminServerInstance.post(`auth/permissions/update?role_id=${roleId}`, {
    ability_ids: abilities,
  }),
  {
    type: type.UPDATE_ROLE_ABILITIES,
    success: type.UPDATE_ROLE_ABILITIES_SUCCESS,
    fail: type.UPDATE_ROLE_ABILITIES_FAIL,
  }
);

export const setDefaultWarehouse = (id, warehouse) => (dispatch) => execute(dispatch)(
  adminServerInstance.post(`/auth/setwarehouse`, {
    id: id,
    warehouse: warehouse
  }),
  {
    type: type.SET_DEFAULT_WAREHOUSE,
    success: type.SET_DEFAULT_WAREHOUSE_SUCCESS,
    fail: type.SET_DEFAULT_WAREHOUSE_FAIL,
  }
);


export const getDefaultWarehouse = (id) => (dispatch) => execute(dispatch)(

  adminServerInstance.get(`/auth/getdefaultwarehouse?id=${id}`),
  
  {    
  type: type.GET_DEFAULT_WAREHOUSE,
  success: type.GET_DEFAULT_WAREHOUSE_SUCCESS,
  fail: type.GET_DEFAULT_WAREHOUSE_FAIL,
  }
  
  );
